module.exports = __webpack_public_path__ + "img/6-vidio.2a47d7ca.jpg";